import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const IRREPLACEABLE_HABITATS: Layer = {
  id: "irreplacable_habitats",
  layerType: ConstraintsLayerType,
  title: "Irreplaceable habitats",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.POLICY,
  icon: "lt-shield-keyhole-line",
  description: "Conserves nature and its ecosystem",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.HABITATS,
    categorySchema: [
      { key: "ancient_tree_inventory" },
      { key: "spartina_saltmarsh_swards" },
      { key: "mediterranean_saltmarsh_scrub" },
      { key: "blanket_bog" },
      { key: "lowland_fens" },
      { key: "limestone_pavements" },
      { key: "coastal_sand_dunes" },
      { key: "ancient_woodland" },
    ],
  },
};
